// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__j9f24","info":"PatientInfo_info__1sJyo"};